"use client";
import { useEffect } from "react";
import { ensureSessionOrRedirect } from "@/lib/api";
import { useTranslation, useLangRouter } from "@/lib/i18n/context";
import { Loading } from "@booking/core-ui/loading";

export default function AdminRoot() {
  const router = useLangRouter();
  const { t } = useTranslation();
  useEffect(() => {
    ensureSessionOrRedirect(router.replace).then((payload) => {
      if (payload) {
        router.replace("/dashboard");
      }
    });
  }, [router]);
  return <Loading>{t("redirecting")}</Loading>;
}
